import React from "react";
import { useNavigate, useLocation } from "react-router";
import { useTranslation } from "react-i18next";
import {
  SGridCard,
  SGridContainer,
  SGridRow2,
  SGridRow3,
  LeftInputColumn,
  RightInputColumn,
  SGridRow4,
  SAddAssets,
  SAddIcon,
} from "./styles";
import { Header } from "./Header/Header";
import { Footer } from "./Footer/Footer";
import { PortfolioSummaryDonutChart } from "./PortfolioSummaryGraph/PortfolioSummaryGraph";
import { PortfolioName } from "./PortfolioName/PortfolioName";
import { PortfolioTotalAmount } from "./PortfolioTotalAmount/PortfolioTotalAmount";
import { PortfolioEditorAssetsList } from "./PortfolioEditorAssetsList/PortfolioEditorAssetsList";
import { PortfolioSummaryDonutChartLegend } from "./PortfolioSummaryGraphLegend/PortfolioSummaryGraphLegend";
import { BalancingButton } from "./BalancingButton/BalancingButton";

export const PortfolioEditor: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();

  const handleAddAsset = (): void => {
    navigate("../", { replace: true });
  };

  return (
    <SGridContainer>
      <SGridCard>
        <Header />
        <SGridRow2>
          <PortfolioSummaryDonutChart />
          <PortfolioSummaryDonutChartLegend />
        </SGridRow2>
        <SGridRow3>
          <LeftInputColumn>
            <PortfolioName />
          </LeftInputColumn>
          <RightInputColumn>
            <PortfolioTotalAmount />
            <BalancingButton />
          </RightInputColumn>
        </SGridRow3>
        {location.pathname === "/analysis" ? (
          <SGridRow4>
            <SAddAssets onClick={handleAddAsset}>
              <SAddIcon />
              {t("portfolioEditorAddAsset")}
            </SAddAssets>
          </SGridRow4>
        ) : null}
      </SGridCard>
      <PortfolioEditorAssetsList />
      <Footer />
    </SGridContainer>
  );
};
